export const classes = {
  root: {
    height: 319,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
};
